const themes = [
    {name: 'theme-default', color: '#FF5F6D'},
    {name: 'theme-blue', color: '#6f86d6'},
    {name: 'theme-green', color: '#1abc9c'}
];

export {themes};